'use strict';
var KeyMirror = require('keymirror');

module.exports = {
    ActionTypes: KeyMirror({
        RECEIVED_VALIDATION_RESULT: null,
        RECEIVED_OPTIONS: null,
        RESET_RES_VALIDATION: null,
        RESET_POSTAL_VALIDATION: null,
        FETCHING_ADDRESS_OPTIONS: null
    })
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./constants/AddressConstants.js